import { create } from 'zustand';

import { IRetailerStore } from './types';

export const retailerStoreValues: Readonly<IRetailerStore> = {
  name: '',
  imgId: '',
  status: 'ACTIVE',
  baseIssuanceProductExclusions: [],
  initialValues: {
    retailerValues: {
      regions: [],
      companyId: undefined,
      effectiveTo: undefined,
      effectiveFrom: undefined,
      isContainPii: false,
      isExcludedFromCompanyPostProcessors: false,
    },
    partnerValues: {
      sponsorCode: '',
      manualThreshold: undefined,
      isManualThreshold: false,
      isEnabledBaseIssuance: false,
    },
    enValues: {
      name: '',
      nameTemplate: '',
      imageMetadataId: '',
    },
    frValues: {
      name: '',
      nameTemplate: '',
      imageMetadataId: '',
    },
  },
};

export const retailerStore = create<IRetailerStore>()(() => retailerStoreValues);
